import { Component } from '@angular/core';
import { SettingsService } from "../../_services/settings.service";
import { AlertService } from "../../_services/alert.service";
import { CustomerMap } from "../../_models/crmStats";


@Component({
  selector: 'customers',
  templateUrl: 'customers.html'
})

export class CustomersComponent {
  hello = "setup";
  customerList: CustomerMap[] = [];
  customerSearch: string = "";
  invoiceSettings = this.settings.invoiceSettings;

  constructor(public settings: SettingsService,
    private alert: AlertService) {
    let scope = this;
    settings.getCustomerMap().subscribe((data: CustomerMap[]) => {
      scope.customerList = data;
    });

  }

  edit(cus: CustomerMap) {
    if (cus.edit) {
      if (cus.CRMName == "" && cus.XeroName == "") {
        this.alert.error("Both fields needed please");
      }
      else {
        cus.edit = false;
        this.settings.updateCustomer(cus).subscribe((res) => {
          console.log(res);
        });
      }
    }
    else {
      cus.tempCRM = cus.CRMName;
      cus.tempXero = cus.XeroName;
      cus.edit = true;
    }
  }
  cancelCus(cus: CustomerMap) {
    cus.CRMName = cus.tempCRM;
    cus.XeroName = cus.tempXero;
    cus.edit = false;
  }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/components/customers/customers.ts